import { render } from "./rsg-logo.vue?vue&type=template&id=651312e4"
import script from "./rsg-logo.vue?vue&type=script&lang=js"
export * from "./rsg-logo.vue?vue&type=script&lang=js"

import "./rsg-logo.vue?vue&type=style&index=0&id=651312e4&lang=sass"

import exportComponent from "/builds/WebServers/festival/leaderboards/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__